export default __webpack_public_path__ + "static/media/zip.a28ca6f2.png";